import React from 'react';
import {Container, Row, Col} from "react-bootstrap";
import {GetText} from "../context/text.js";
import {Helmet} from "react-helmet";

function About() {
    let text = GetText();

    return (
        <div>
            <Helmet>
                <title>{text.Contacts.title + ' - ' + text.Header.name} - zapauto.com.ua</title>
                <meta name="description" content={
                    text.Contacts.tel + ': +38 (068) 822-52-52, +38 (068) 922-52-52' + ', '
                    + text.Contacts.email + ': info@zapauto.com.ua' + ', '
                    + text.Contacts.schedule + ': 10:00 - 20:00' + ', '
                    + text.Contacts.address + ': ' + text.Contacts.addressInfo + ', '
                    + text.Contacts.delivery + ': ' + text.Contacts.deliveryInfo
                }/>
                <meta name="keywords"
                      content={text.Contacts.title + ', ' + text.Contacts.tel + ', ' + text.Contacts.email + ', ' + text.Contacts.address + ', ' + text.Contacts.delivery}/>
            </Helmet>

            <Container>
                <Row>
                    <Col lg={6} md={6} sm={12} xs={12}>

                        <h3><b>{text.Contacts.title}:</b></h3>

                        <p><b>{text.Contacts.tel}:</b> +38 (068) 822-52-52, +38 (068) 922-52-52</p>

                        <p><b>{text.Contacts.email}:</b> <a href="mailto:info@zapauto.com.ua">info@zapauto.com.ua</a>
                        </p>

                        <p><b>{text.Contacts.schedule}:</b> {text.Contacts.scheduleDay} (10:00 - 20:00), {text.Contacts.scheduleDay2} ({text.Contacts.nedila}) </p>

                        <p><b>{text.Contacts.address}:</b> {text.Contacts.addressInfo}</p>

                       { <p><b>{text.Contacts.delivery}:</b></p>}
                       { <p> {text.Contacts.deliveryInfo}</p>}
                       { <p> {text.Contacts.deliveryInfo2}</p>}
                       { <p> {text.Contacts.deliveryInfo3}</p>}
                       { <p> {text.Contacts.deliveryInfo4}</p>}

                        <p>ZapAuto</p>


                    </Col>
                    <Col lg={6} md={6} sm={12} xs={12}>
                        <a target="_blank"  rel="noreferrer" href={'https://maps.app.goo.gl/LcidnWovksawg6P99'}>
                          <img id="logo" title="Zapauto" alt="Zapauto" className="maps" src="https://zapauto.com.ua/backend/public/images/maps.png" />
                        </a>
                    </Col>
                </Row>
            </Container>


        </div>
    )
}

export default About
